import styled from 'styled-components';

export const Input = styled.input<{
  $isRequired: boolean;
  $isDisabled: boolean;
  $isValid?: boolean;
  $textAlign?: string;
}>`
  width: 100%;
  flex-grow: 1;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${({ theme: { color }, $isValid }) => ($isValid ? color.ui2 : color.ac11)};
  ${({ theme: { font } }) => font.t2}
  ${({ $textAlign }) => ($textAlign ? `text-align: ${$textAlign};` : '')}

  &:focus {
    outline: none;
  }
`;

export const Container = styled.div<{
  $width?: string | number;
}>`
  position: relative;
  width: ${({ $width }) => $width ?? '100%'};
  height: 32px;
`;

export const InputContainer = styled.div<{
  $isValid: boolean;
}>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  width: 100%;
  height: 100%;
  border: ${({ theme: { color }, $isValid }) => ($isValid ? 'none' : `1px solid ${color.ac11}`)};
  padding: 6px 8px;
  border-radius: ${({ theme: { radius } }) => radius.xs};
  background-color: ${({ theme: { color } }) => color.ui5};
  box-shadow: ${({ theme: { shadows } }) => shadows.fieldShadow};
  cursor: text;

  &:hover {
    box-shadow: ${({ theme: { shadows } }) => shadows.innerShadow};
  }
`;

export const Icon = styled.div`
  width: 16px;
  height: 20px;
  fill: ${({ theme: { color } }) => color.ui3};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EyeButton = styled.button<{ $isHidden: boolean }>`
  width: 16px;
  height: 20px;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;

  cursor: pointer;
  fill: ${({ theme: { color }, $isHidden }) => ($isHidden ? color.ui4 : color.ui2)};
`;

export const CharCount = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  color: ${({ theme: { color } }) => color.ui3};
  ${({ theme: { font } }) => font.t2}
  white-space: nowrap;
  gap: 1px;
`;

export const FullWidth = styled.div`
  width: 100%;
`;
